import React from "react";

const SectionTitle = ({ className, value, children }) => {
  // Handle the special case first
  const displayValue = value === "Top 10 Edits" ? "Manage Supreme Essentials & For You" : value;
  
  // Check if there's a dash and split the title
  const hasDash = displayValue.includes(' - ');
  const parts = hasDash ? displayValue.split(' - ') : [displayValue];
  
  return (
    <div className="flex flex-row items-center justify-center h-full">
      <p
        className={`topic-title ${className} text-transparent  text-[16px] sm:text-[18px] md:text-[22px] lg:text-[29px] xl:text-[30px] font-wite`}
      >
        {hasDash ? (
          <>
            <span>{parts[0]}</span>
            <span className="text-[20px]"> - {parts[1]}</span>
          </>
        ) : (
          displayValue
        )}
      </p>
      <div className="flex flex-1" />
      {children}
    </div>
  );
};

const SectionAction = ({ name, action }) => {
  return (
    <div
      className="block w-fit h-full ps-5 cursor-pointer"
      onClick={action ? () => action() : null}
    >
      <p className="underline lowercase first-letter:uppercase text-text-secondary text-[16px] underline-offset-4 leading-6">
        {name}
      </p>
    </div>
  );
};

export { SectionTitle, SectionAction };
